import i18n from "i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

const WIS_URL = localStorage.getItem("WIS_URL");
const INIT_LANG = localStorage.getItem("i18n") || "en";

i18n
  // load translation using xhr -> see /public/locales
  // learn more: https://github.com/i18next/i18next-xhr-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    lng: INIT_LANG,
    fallbackLng: "en",
    backend: {
      loadPath: `${WIS_URL}/locales/{{lng}}/{{ns}}.json`,
      crossDomain: true,
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
      format: (value, format) => {
        if (format === "capitalize") {
          return value[0].toUpperCase() + value.slice(1);
        }

        return value;
      },
    },
    load: "languageOnly",
  });

export default i18n;
